import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { getAttendanceList } from "_controllers/officer";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import moment from "moment";
import { toastMessage } from "utils/toastMessage";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import UpdateIcon from "@mui/icons-material/Update";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import GetAppIcon from "@mui/icons-material/GetApp";
import exportExcel from "utils/excelGenerate";
import authAxios from "setups/axios";
import Chip from "@mui/material/Chip";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import { PageHeader, StatCard, TablePager } from "_shared/ui";

const messageStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  textAlign: "center",
};

// Map an attendance status to a theme semantic color for the status Chip.
const getStatusColor = (status) => {
  if (!status) return "default";
  if (status.includes("Late")) return "warning";
  if (status === "Leave Approved") return "info";
  if (status === "Leave Rejected") return "error";
  if (status === "Leave Applied") return "warning";
  return "success";
};

const Main = () => {
  const [data, setData] = useState([]);
  const [csvData, setcsvData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();

  const [open, setOpen] = useState(false);
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");

  const [zone, setZone] = useState("");
  const [region, setRegion] = useState("");
  const [area, setArea] = useState("");
  const [search, setSearch] = useState("");

  const [rowData, setRowData] = useState();
  const [remark, setRemark] = useState("");

  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);

  const zoneList = [
    { zone: "NZ", name: "North Zone" },
    { zone: "SZ", name: "South Zone" },
    { zone: "WZ", name: "West Zone" },
    { zone: "EZ", name: "East Zone" },
    { zone: "TZ", name: "South Zone II" },
  ];

  const regionList = [
    { regionCode: 1682, name: "Nepal" },
    { regionCode: 1182, name: "GUWAHATI" },
    { regionCode: 1681, name: "Patna" },
    { regionCode: 3181, name: "DELHI" },
    { regionCode: 3281, name: "FARIDABAD" },
    { regionCode: 3381, name: "JALLANDHAR" },
    { regionCode: 3681, name: "JAIPUR" },
    { regionCode: 3682, name: "JODHPUR" },
    { regionCode: 3781, name: "KANPUR" },
    { regionCode: 3782, name: "MEERUT" },
    { regionCode: 3783, name: "VARANASI" },
    { regionCode: 5181, name: "H.BAD" },
    { regionCode: 5182, name: "VIJAYWADA" },
    { regionCode: 5381, name: "CHENNAI" },
    { regionCode: 5382, name: "Cochin" },
    { regionCode: 7181, name: "INDORE" },
    { regionCode: 1683, name: "RANCHI" },
    { regionCode: 7381, name: "MUMBAI" },
    { regionCode: 7382, name: "NAGPUR" },
    { regionCode: 7581, name: "AHMEDABAD" },
    { regionCode: 1181, name: "KOLKATTA" },
    { regionCode: 7182, name: "RAIPUR" },
    { regionCode: 7183, name: "JABALPUR" },
    { regionCode: 7184, name: "CUTTAK" },
    { regionCode: 5281, name: "BNGLR" },
    { regionCode: 3382, name: "CHANDIGARH" },
    { regionCode: 5282, name: "HUBLI" },
    { regionCode: 5383, name: "Coimbatore" },
    { regionCode: 7582, name: "RAJKOT" },
  ];

  useEffect(async () => {
    const attendance = await getAttendanceList({
      currentPage: currentPage,
      search,
      zone,
      region,
      area,
    });
    setData(attendance?.data);
    setCount(attendance?.clockCount);
    setMessage(attendance?.message);
    setCurrentPage(attendance?.data.length > 0 ? attendance?.currentPage : 1);
    setLoading(true);
    setTotalPages(attendance?.totalPage ?? 1);
    setcsvData(attendance?.csvData);
  }, [message, currentPage, search]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  let fileName = "Attendance-Data";

  const generateExcel = async (e) => {
    e.preventDefault();
    exportExcel(
      csvData.map((x) => ({
        Date: moment.utc(x?.onDate).format("DD/MM/YYYY"),
        "SAP ID": x?.SAP_ID,
        Zone: x?.userId?.zone,
        Region: x?.userId?.regionCode,
        Area: x?.userId?.areaName,
        "Check In Time": x?.checkIn
          ? moment.utc(x?.checkIn.time).format("h:mm A")
          : "-",
        "Check Out Time": x?.checkOut
          ? moment.utc(x?.checkOut.time).format("h:mm A")
          : "-",
      })),
      fileName
    );
  };

  const approveLeave = async () => {
    await authAxios()({
      url: `/api/v1/attendance/approve`,
      method: "PUT",
      data: rowData,
    })
      .then((res) => {
        toastMessage(res?.data?.message, "success");
        setMessage(res?.data?.message);
        setApproveModal(false);
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage(err?.data?.message, "error");
      });
  };

  const rejectLeave = async () => {
    await authAxios()({
      url: `/api/v1/attendance/reject`,
      method: "PUT",
      data: { ...rowData, remark },
    })
      .then((res) => {
        toastMessage(res?.data?.message, "success");
        setMessage(res?.data?.message);
        setRemark("");
        setRejectModal(false);
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage(err?.data?.message, "error");
      });
  };

  const updateTimeChange = async (type) => {
    let dataObj = {
      attendanceId: rowData._id,
      decision: type,
      remarks: remark,
    };
    await authAxios()({
      url: `/api/v1/attendance/updateAttendanceRequest`,
      method: "PUT",
      data: dataObj,
    })
      .then((res) => {
        toastMessage(res?.data?.message, "success");
        setMessage(res?.data?.message);
        setUpdateModal(false);
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage(err?.data?.message, "error");
      });
  };

  // console.log(
  //   "row",
  //   (count?.statusCounts?.["Present"] ?? 0) +
  //     (count?.statusCounts?.["Early CheckOut"] ?? 0) +
  //     (count?.statusCounts?.["Late CheckIn - Early CheckOut"] ?? 0) +
  //     (count?.statusCounts?.["Late CheckIn"] ?? 0) +
  //     (count?.statusCounts?.["Leave Rejected"] ?? 0) +
  //     (count?.statusCounts?.["Training"] ?? 0) +
  //     (count?.statusCounts?.["Office"] ?? 0) +
  //     (count?.statusCounts?.["Meeting"] ?? 0)
  // );

  console.log("row data", rowData);

  const sc = count?.statusCounts ?? {};
  const presentCount =
    (sc["Present"] ?? 0) +
    (sc["Early CheckOut"] ?? 0) +
    (sc["Late CheckIn - Early CheckOut"] ?? 0) +
    (sc["Late CheckIn"] ?? 0) +
    (sc["Leave Rejected"] ?? 0) +
    (sc["Training"] ?? 0) +
    (sc["Office"] ?? 0) +
    (sc["Meeting"] ?? 0);
  const leaveCount = Math.round(sc["Leave Approved"] ?? 0);
  const onTimeCount = (sc["Present"] ?? 0) + (sc["Early CheckOut"] ?? 0);
  const lateCount =
    (sc["Late CheckIn"] ?? 0) + (sc["Late CheckIn - Early CheckOut"] ?? 0);

  return (
    <>
      <PageHeader title="Attendance" subtitle="Daily attendance report" />
      <Grid container spacing={2.5} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label="Present"
            value={presentCount}
            icon={CheckCircleOutlineIcon}
            color="success"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label="Leave"
            value={leaveCount}
            icon={EventBusyOutlinedIcon}
            color="error"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label="On Time"
            value={onTimeCount}
            icon={AccessTimeIcon}
            color="info"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label="Late"
            value={lateCount}
            icon={RunningWithErrorsIcon}
            color="warning"
          />
        </Grid>
      </Grid>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "2rem",
        }}
      >
        <div>
          <Typography variant="h6" sx={{ fontWeight: 700, m: 2 }}>
            Attendance List
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "2rem",
            // width: "55%",
          }}
        >
          <TextField
            size="small"
            value={search}
            name="search"
            placeholder="Search for SAP ID"
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ mr: 2 }}
          />
          {/* <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="zone-label">Zone</InputLabel>
            <Select
              labelId="zone-label"
              value={zone}
              name="zone"
              onChange={(event) => setZone(event.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {zoneList?.map((item) => (
                <MenuItem key={item} value={item?.zone}>
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          {/* <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="zone-label">Region</InputLabel>
            <Select
              labelId="zone-label"
              value={region}
              name="zone"
              onChange={(event) => setRegion(event.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {regionList?.map((item) => (
                <MenuItem key={item} value={item?.regionCode}>
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          <Button
            variant="contained"
            onClick={generateExcel}
            startIcon={<GetAppIcon />}
          >
            Download
          </Button>
        </div>
      </div>
      {loading ? (
        <>
          <TableContainer component={Paper} sx={{ mt: 2.5, width: "99%" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                    Date
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    SAP ID
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Zone
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Region
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Area
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Check In Time
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Check Out Time
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Status
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Leave Action
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Edit Request
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data?.length > 0 ? (
                  data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">
                        {moment.utc(d?.onDate).format("DD/MM/YYYY")}
                      </TableCell>
                      <TableCell align="center">{d?.SAP_ID}</TableCell>
                      <TableCell align="center">{d?.userId?.zone}</TableCell>
                      <TableCell align="center">
                        {d?.userId?.regionCode}
                      </TableCell>
                      <TableCell align="center">
                        {d?.userId?.areaName}
                      </TableCell>
                      <TableCell align="center">
                        {d?.status !== "Leave Approved" ? (
                          <>
                            <span>
                              {d?.checkIn
                                ? moment
                                    .utc(d?.checkIn.time)
                                    .add(330, "minute")
                                    .format("h:mm A")
                                : "-"}
                            </span>
                            {d?.checkIn ? (
                              <>
                                <LocationOnIcon
                                  sx={{
                                    cursor: "pointer",
                                    color: "green",
                                    marginLeft: "10px",
                                  }}
                                  onClick={() => {
                                    setLat(
                                      d?.checkIn
                                        ? d?.checkIn?.location?.lat
                                        : "NA"
                                    );
                                    setLong(
                                      d?.checkIn
                                        ? d?.checkIn?.location?.long
                                        : "NA"
                                    );
                                    setOpen(true);
                                  }}
                                />
                              </>
                            ) : null}
                          </>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {d?.status !== "Leave Approved" ? (
                          <>
                            {d?.checkOut
                              ? moment
                                  .utc(d?.checkOut.time)
                                  .add(330, "minute")
                                  .format("h:mm A")
                              : "-"}
                            {d?.checkOut?.location ? (
                              <LocationOnIcon
                                sx={{
                                  cursor: "pointer",
                                  color: "green",
                                  marginLeft: "10px",
                                }}
                                onClick={() => {
                                  setOpen(true);
                                  setLat(
                                    d?.checkOut
                                      ? d?.checkOut?.location?.lat
                                      : "NA"
                                  );
                                  setLong(
                                    d?.checkOut
                                      ? d?.checkOut?.location?.long
                                      : "NA"
                                  );
                                }}
                              />
                            ) : null}
                          </>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          size="small"
                          label={
                            d?.leaveType
                              ? `${d?.status} (${d?.leaveType})`
                              : d?.status
                          }
                          color={getStatusColor(d?.status)}
                          variant={
                            getStatusColor(d?.status) === "default"
                              ? "outlined"
                              : "filled"
                          }
                        />
                      </TableCell>
                      <TableCell>
                        {d?.leaveType ? (
                          d?.status === "Leave Rejected" ||
                          d?.status === "Leave Approved" ? null : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Button
                                variant="contained"
                                color="success"
                                size="small"
                                onClick={() => {
                                  setApproveModal(true);
                                  setRowData(d);
                                }}
                              >
                                Approve
                              </Button>
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                sx={{ ml: 1 }}
                                onClick={() => {
                                  setRejectModal(true);
                                  setRowData(d);
                                }}
                              >
                                Reject
                              </Button>
                            </div>
                          )
                        ) : null}
                      </TableCell>
                      <TableCell align="center">
                        {d?.status === "Leave Applied" ||
                        d?.status === "Leave Approved" ||
                        d?.status === "Leave Rejected" ? null : (
                          <VisibilityIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setUpdateModal(true);
                              setRowData(d);
                              setLat(d?.checkIn?.location?.lat);
                              setLong(d?.checkIn?.location?.long);
                            }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <Box sx={{ textAlign: "left", pt: 1 }}>
                    <Typography variant="h6" sx={{ p: 1 }}>
                      No Attendance List Avilable.
                    </Typography>
                  </Box>
                )}
              </TableBody>
            </Table>
            <TablePager
              totalPages={totalPages}
              page={currentPage}
              onPageChange={(p) => handlePageChange(null, p)}
            />
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )}

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={messageStyle}>
          {console.log("lat", lat, long)}
          <iframe
            src={`https://maps.google.com/maps?q=${lat},${long}&hl=es;&output=embed`}
            height="500px"
            width="100%"
          ></iframe>
        </Box>
      </Modal>

      <Modal
        open={approveModal}
        onClose={() => {
          setApproveModal(false);
        }}
      >
        <Box
          sx={{
            width: "40%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "none",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
            borderRadius: "8px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "left",
                // padding: "1rem 0",
              }}
            >
              Sure you want to approve?
            </p>
            <p
              style={{ color: "#54595E", fontWeight: "400", marginTop: "1rem" }}
            >
              This action will approve leave.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                marginTop: "1.5rem",
              }}
            >
              <button
                style={{
                  backgroundColor: "rgba(209, 209, 209, 1)",
                  padding: "14px 20px",
                  borderRadius: "8px",
                  height: "44px",
                  width: "40%",
                  border: "1px solid #3273F6",
                  color: "#3273F6",
                  cursor: "pointer",
                }}
                onClick={() => setApproveModal(false)}
              >
                No, cancel
              </button>
              <button
                style={{
                  backgroundColor: "#3273F6",
                  padding: "14px 20px",
                  borderRadius: "8px",
                  height: "44px",
                  width: "40%",
                  color: "#ffffff",
                  cursor: "pointer",
                }}
                onClick={approveLeave}
              >
                Yes, confirm
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={updateModal}
        onClose={() => {
          setUpdateModal(false);
          setRemark("");
          setRowData();
        }}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "75%",
            maxHeight: "95vh",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            bgcolor: "background.paper",
            border: "none",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
            borderRadius: "8px",
          }}
        >
          <div style={{ borderBottom: "1px solid darkgrey" }}>
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "left",
                marginBottom: "1rem",
                // padding: "1rem 0",
                color: "#333842",
              }}
            >
              Check-In & Check-Out
            </p>
          </div>

          <div
            style={{
              borderBottom: "2px solid #DCDEE5",
              marginTop: "1rem",
              display: "flex",
            }}
          >
            <div style={{ width: "50%" }}>
              <p style={{ color: "#333842" }}>Check-In Time</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "14px",
                  border: "1px solid #DCDEE5",
                  borderRadius: "5px",
                  marginTop: "10px",
                }}
              >
                <p style={{ fontSize: "14px" }}>
                  {rowData?.checkIn?.time
                    ? moment
                        .utc(rowData?.checkIn?.time)
                        .add(330, "minutes")
                        .format("hh:mm A")
                    : "-"}
                </p>
                <p
                  style={{
                    textDecoration: "underline",
                    fontSize: "14px",
                    color: "#1976d2",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setLat(rowData?.checkIn?.location?.lat);
                    setLong(rowData?.checkIn?.location?.long);
                  }}
                >
                  Show Map
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: "5px",
                  boxShadow: `rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px`,
                  margin: "1rem 0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                >
                  <div>
                    <ScheduleIcon
                      style={{ cursor: "pointer", color: "#C1C1CC" }}
                    />
                  </div>
                  <div style={{ marginLeft: "1rem" }}>
                    <p style={{ color: "#696973", fontSize: "12px" }}>
                      Server Time
                    </p>
                    <p style={{ color: "#333842", fontSize: "14px" }}>
                      {rowData?.serverCheckInTime
                        ? moment
                            .utc(rowData?.serverCheckInTime)
                            .add(330, "minutes")
                            .format("hh:mm A")
                        : "-"}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                >
                  <div>
                    <SwapHorizIcon
                      style={{ cursor: "pointer", color: "#C1C1CC" }}
                    />
                  </div>
                  <div style={{ marginLeft: "1rem" }}>
                    <p style={{ color: "#696973", fontSize: "12px" }}>
                      Difference
                    </p>
                    <p style={{ color: "#333842", fontSize: "14px" }}>
                      {moment(rowData?.serverCheckInTime).diff(
                        moment(rowData?.checkIn?.time),
                        "minutes"
                      )}
                      {" min"}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                >
                  <div>
                    <CallSplitIcon
                      style={{
                        cursor: "pointer",
                        color: "#C1C1CC",
                        transform: "rotate(90deg)",
                      }}
                    />
                  </div>
                  <div style={{ marginLeft: "1rem" }}>
                    <p style={{ color: "#696973", fontSize: "12px" }}>
                      Proximity
                    </p>
                    <p style={{ color: "#333842", fontSize: "14px" }}>WIP</p>
                  </div>
                </div>
              </div>

              <p style={{ marginTop: "1rem", color: "#333842" }}>
                Check-Out Time
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "14px",
                  border: "1px solid #DCDEE5",
                  borderRadius: "5px",
                  marginTop: "10px",
                }}
              >
                <p style={{ fontSize: "14px" }}>
                  {rowData?.checkOut?.time
                    ? moment
                        .utc(rowData?.checkOut?.time)
                        .add(330, "minutes")
                        .format("hh:mm A")
                    : "-"}
                </p>
                <p
                  style={{
                    textDecoration: "underline",
                    fontSize: "14px",
                    color: "#1976d2",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setLat(rowData?.checkOut?.location?.lat);
                    setLong(rowData?.checkOut?.location?.long);
                  }}
                >
                  Show Map
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: "5px",
                  boxShadow: `rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px`,
                  margin: "1rem 0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                >
                  <div>
                    <ScheduleIcon
                      style={{ cursor: "pointer", color: "#C1C1CC" }}
                    />
                  </div>
                  <div style={{ marginLeft: "1rem" }}>
                    <p style={{ color: "#696973", fontSize: "12px" }}>
                      Server Time
                    </p>
                    <p style={{ color: "#333842", fontSize: "14px" }}>
                      {rowData?.serverCheckOutTime
                        ? moment
                            .utc(rowData?.serverCheckOutTime)
                            .add(330, "minutes")
                            .format("hh:mm A")
                        : "-"}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                >
                  <div>
                    <SwapHorizIcon
                      style={{ cursor: "pointer", color: "#C1C1CC" }}
                    />
                  </div>
                  <div style={{ marginLeft: "1rem" }}>
                    <p style={{ color: "#696973", fontSize: "12px" }}>
                      Difference
                    </p>
                    <p style={{ color: "#333842", fontSize: "14px" }}>
                      {moment(rowData?.serverCheckOutTime).diff(
                        moment(rowData?.checkOut?.time),
                        "minutes"
                      )}
                      {" min"}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                >
                  <div>
                    <CallSplitIcon
                      style={{
                        cursor: "pointer",
                        color: "#C1C1CC",
                        transform: "rotate(90deg)",
                      }}
                    />
                  </div>
                  <div style={{ marginLeft: "1rem" }}>
                    <p style={{ color: "#696973", fontSize: "12px" }}>
                      Proximity
                    </p>
                    <p style={{ color: "#333842", fontSize: "14px" }}>WIP</p>
                  </div>
                </div>
              </div>
              <p style={{ fontSize: "14px", marginBottom: "1rem" }}>
                Dealer found within 100m: <span>WIP</span>
              </p>
            </div>
            <div style={{ width: "50%", padding: "1rem" }}>
              <iframe
                src={`https://maps.google.com/maps?q=${lat},${long}&hl=es;&output=embed`}
                height="100%"
                width="100%"
              ></iframe>
            </div>
          </div>

          {rowData?.updateRequest?.status === "PENDING" ||
          rowData?.updateRequest?.status === "REJECTED" ||
          rowData?.updateRequest?.status === "APPROVED" ? (
            <>
              <div
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "8px",
                  marginTop: "1rem",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "1rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <BorderColorIcon
                        style={{ cursor: "pointer", color: "#C1C1CC" }}
                      />
                    </div>
                    <div style={{ marginLeft: "1rem" }}>
                      <p style={{ color: "#54575E", fontSize: "12px" }}>
                        User Remark
                      </p>
                      <p
                        style={{
                          color: "#333842",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        {rowData?.updateRequest?.remarks
                          ? rowData?.updateRequest?.remarks
                          : "-"}
                      </p>
                    </div>
                  </div>

                  <button
                    style={{
                      color:
                        rowData?.updateRequest?.status === "PENDING"
                          ? "orange"
                          : rowData?.updateRequest?.status === "APPROVED"
                          ? "green"
                          : "red",
                      fontSize: "16px",
                      fontWeight: "600",
                      fontFamily: "Arial, sans-serif",
                      letterSpacing: "1px",
                    }}
                  >
                    {rowData?.updateRequest?.status}
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "1rem",
                    }}
                  >
                    <div>
                      <CalendarMonthIcon
                        style={{ cursor: "pointer", color: "#C1C1CC" }}
                      />
                    </div>
                    <div style={{ marginLeft: "1rem" }}>
                      <p style={{ color: "#696973", fontSize: "12px" }}>Date</p>
                      <p style={{ color: "#333842", fontSize: "14px" }}>
                        {moment.utc(rowData?.onDate).format("DD/MM/YYYY")}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "1rem",
                    }}
                  >
                    <div>
                      <UpdateIcon
                        style={{ cursor: "pointer", color: "#C1C1CC" }}
                      />
                    </div>
                    <div style={{ marginLeft: "1rem" }}>
                      <p style={{ color: "#696973", fontSize: "12px" }}>
                        Status
                      </p>
                      <p style={{ color: "#333842", fontSize: "14px" }}>
                        {rowData?.status}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "1rem",
                    }}
                  >
                    <div>
                      <ScheduleIcon
                        style={{ cursor: "pointer", color: "#C1C1CC" }}
                      />
                    </div>
                    <div style={{ marginLeft: "1rem" }}>
                      <p style={{ color: "#696973", fontSize: "12px" }}>Time</p>
                      <p style={{ color: "#333842", fontSize: "14px" }}>
                        {rowData?.checkIn
                          ? moment
                              .utc(rowData?.checkIn?.time)
                              .add(330, "minutes")
                              .format("hh:mm A")
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "1rem",
                    }}
                  >
                    <div>
                      <ScheduleIcon
                        style={{ cursor: "pointer", color: "#C1C1CC" }}
                      />
                    </div>
                    <div style={{ marginLeft: "1rem" }}>
                      <p style={{ color: "#696973", fontSize: "12px" }}>
                        Updated Time
                      </p>
                      <p style={{ color: "#333842", fontSize: "14px" }}>
                        {rowData?.updateRequest?.checkIn
                          ? moment
                              .utc(rowData?.updateRequest?.checkIn?.time)
                              .add(330, "minutes")
                              .format("hh:mm A")
                          : "-"}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "1rem",
                    }}
                  >
                    <div>
                      <BorderColorIcon
                        style={{ cursor: "pointer", color: "#C1C1CC" }}
                      />
                    </div>
                    <div style={{ marginLeft: "1rem" }}>
                      <p style={{ color: "#696973", fontSize: "12px" }}>
                        Total Hours
                      </p>
                      <p style={{ color: "#333842", fontSize: "14px" }}>
                        {moment(rowData?.updateRequest?.checkOut?.time).diff(
                          moment(rowData?.updateRequest?.checkIn?.time),
                          "hours"
                        )}
                        {" Hrs"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}

          {rowData?.updateRequest?.status === "PENDING" ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "1.5rem",
                }}
              >
                <TextField
                  sx={{ mt: 1, mb: 2 }}
                  onChange={(e) => setRemark(e.target.value)}
                  name="remark"
                  value={remark}
                  fullWidth
                  label="Enter Remark"
                  variant="outlined"
                />
                <div>
                  <button
                    style={{
                      backgroundColor: "#EEC858",
                      padding: "14px 20px",
                      borderRadius: "8px",
                      height: "44px",
                      width: "150px",
                      color: "#54575E",
                      fontWeight: "700",
                      letterSpacing: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() => updateTimeChange("APPROVED")}
                  >
                    Approve
                  </button>
                  <button
                    style={{
                      backgroundColor: "#ffffff",
                      padding: "14px 20px",
                      borderRadius: "8px",
                      height: "44px",
                      width: "150px",
                      border: "1px solid #DCDEE5",
                      color: "#54575E",
                      fontWeight: "700",
                      letterSpacing: "2px",
                      cursor: "pointer",
                      marginLeft: "3rem",
                    }}
                    onClick={() => updateTimeChange("REJECTED")}
                  >
                    Reject
                  </button>
                </div>
              </div>
            </>
          ) : null}
        </Box>
      </Modal>

      <Modal
        open={rejectModal}
        onClose={() => {
          setRejectModal(false);
        }}
      >
        <Box
          sx={{
            width: "40%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "none",
            boxShadow: 24,
            p: "2rem",
            textAlign: "left",
            letterSpacing: 1,
            borderRadius: "8px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p
              style={{
                fontFamily: "Inter",
                fontSize: "18px",
                fontWeight: "500",
                lineHeight: "24px",
                textAlign: "left",
                fontFamily: "Public Sans",
                // padding: "1rem 0",
              }}
            >
              Please share the reason for rejecting leave.
            </p>
            <p
              style={{
                color: "#54595E",
                fontWeight: "400",
                marginTop: "1rem",
                fontSize: "15px",
                fontFamily: "Public Sans",
              }}
            >
              This would help employees understand why their leave was rejected.
            </p>
            <TextField
              sx={{ mt: 3 }}
              onChange={(e) => setRemark(e.target.value)}
              name="remark"
              value={remark}
              label="Text here"
              variant="outlined"
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1.5rem",
                height: "2.5rem",
              }}
            >
              <button
                style={{
                  backgroundColor: "rgba(168, 170, 174, 0.16)",
                  padding: "10px 30px",
                  borderRadius: "6px",
                  fontWeight: "500",
                  color: "#A8AAAE",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setRejectModal(false);
                  setRemark("");
                }}
              >
                Cancel
              </button>
              <button
                style={{
                  backgroundColor: "#3273F6",
                  padding: "10px 30px",
                  borderRadius: "6px",
                  fontWeight: "500",
                  color: "#ffffff",
                  marginLeft: "1rem",
                  cursor: "pointer",
                }}
                onClick={rejectLeave}
              >
                Submit
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

const AttendanceData = () => {
  return (
    <AccessController roles={["RO", "ZO", "ADMIN", "AO"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default AttendanceData;
